<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{name: 'Appearance'}">
              <h4 class="m-dir-2">
                {{ label.pages.Appearance }}
              </h4>
            </b-link>
            /
            <b-link :to="{name: 'ManagePages'}">
              <h4 class="mx-2">
                {{ label.pages.managePages }}
              </h4>
            </b-link>
            /
            <h4 class="m-dirR-2">
              {{ $route.meta.label }}
            </h4>
          </b-col>
          <b-col sm="2" class="dir-text-start">
            <a
                @click="$router.go(-1)"
                v-b-tooltip.hover.right
                :title=" label.pages.previousPage"
                class="mouse-change pe-3"
            >
              <b-icon
                  icon="arrow-left-square-fill"
                  variant="ps-base"
                  scale="1.2"
                  class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <b-row>
            <b-col cols="6" class="align-self-center py-0">
              <b-row class="my-4">
                <b-col class="align-self-center" cols="2">
                  <label for="title" class="ps_label">
                    {{ label.pages.title }}
                    <span class="ps_label_star">*</span>
                  </label>
                </b-col>
                <b-col class="align-self-center" cols="9">
                  <b-form-input id="title" size="md" v-model="page.title"/>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="6" class="align-self-center py-0">
              <b-row class="my-4">
                <b-col class="align-self-center" cols="3">
                  <label for="name" class="ps_label">
                    {{ label.pages.address }}
                    <span class="ps_label_star">*</span>
                    <b-icon
                        icon="question-circle-fill"
                        scale="1.2"
                        variant="ps-base"
                        class="m-dirR-1 mouse-question"
                        v-b-popover.hover.top="label.pages.suggest "
                    />
                  </label>
                </b-col>
                <b-col dir="ltr" class="align-self-center" cols="9">
                  <b-input-group prepend="page/">
                    <b-form-input id="name" size="md" dir="ltr" v-model="pageName"/>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="6">
              <b-row v-if="dropZoneAction" class="my-4">
                <b-col sm="4">
                  <label for="image" class="ps_label">{{ label.pages.photo }}</label>
                </b-col>
                <b-col sm="auto">
                  <drop-zone-custom
                      mode="image"
                      :isRequired="true"
                      :add="dropZoneAction"
                      :edit="!dropZoneAction"
                      :editSrc="imageAddress"
                  />
                </b-col>
              </b-row>
              <b-row v-if="!dropZoneAction" class="my-4">
                <b-col sm="12">
                  <drop-zone-custom
                      mode="image"
                      :isRequired="true"
                      :add="dropZoneAction"
                      :edit="!dropZoneAction"
                      :editSrc="imageAddress"
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="auto" class="pt-4">
              <label for="language" class="ps_label">
                {{label.pages.contentLanguage}}
                <span class="ps_label_star">*</span>
              </label>
            </b-col>
            <b-col cols="3" class="pt-4">
              <v-select
                input-id="language"
                :options="languages"
                v-model="selectedLanguage"
                :reduce="group => group.id"
                :clearable="false"
                size="sm"
                class="ps_select"
                disabled
              >
              </v-select>
            </b-col>
            <b-col cols="2">
              <b-row class="my-4">
                <b-col cols="auto">
                  <label for="isConfirm" class="ps_label pe-2">
                    {{ label.form.display }}
                  </label>
                </b-col>
                <b-col cols="auto">
                  <label class="ps-switch">
                    <input id="isConfirm" type="checkbox" v-model="page.isConfirm">
                    <span class="slider round"></span>
                  </label>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <b-row class="my-4">
                <b-col cols="3">
                  <label for="shortDescription" class="ps_label">
                    {{ label.pages.summary }}
                    <span class="ps_label_star">*</span>
                    <b-icon
                        icon="question-circle-fill"
                        scale="1.2"
                        variant="ps-base"
                        class="m-dirR-1 mouse-question"
                        v-b-popover.hover.top="label.pages.Description "
                    />
                  </label>
                </b-col>
                <b-col cols="9">
                  <b-form-textarea id="shortDescription" size="sm" rows="2" v-model="page.shortDescription"/>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <b-row class="my-4">
                <b-col cols="12">
                  <label for="text" class="ps_label pe-2">
                    {{ label.pages.content }}
                  </label>
                  <DxHtmlEditor v-model="page.text" :height="editorHeight" >
                    <DxMediaResizing :enabled="mediaResize" />
                    <DxImageUpload
                            :tabs="imageUploadType"
                            :file-upload-mode="imageUploadMode"
                    />
                    <DxToolbar :multiline="multilineToolbar">
                      <DxItem :accepted-values="headerValues" name="header" />
                      <DxItem :accepted-values="sizeValues" name="size" />
                      <DxItem :accepted-values="fontValues" name="font" />
                      <DxItem name="separator" />
                      <DxItem
                              v-for="toolbar in editorToolbar"
                              :key="toolbar.id"
                              :name="toolbar.name"
                      />
                    </DxToolbar>
                  </DxHtmlEditor>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card-body>
      <template #footer>
        <div class="d-flex justify-content-end">
          <button
              @click="$router.go(-1)"
              class="m-dir-2"
              size="sm"
              v-b-tooltip.hover
              :title="label.pages.returnPage"
          >
            <b-icon
                icon="arrow-right-square-fill"
                scale="2"
                class="pt-1"
                variant="ps-secondary-icon"
            >
            </b-icon>
          </button>
          <b-button
              v-if="!loadingBtn"
              variant="ps-success"
              size="sm"
              class="mx-1"
              @click="editPage"
          >
            <b-icon icon="check2-circle" class="m-dir-1"/>
            {{ label.buttons.saveChanges }}
          </b-button>
          <b-button
              v-else
              disabled
              variant="ps-success"
              size="sm"
              class="mx-1"
          >
            <b-spinner small></b-spinner>
          </b-button>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import { devExtremeEditor } from "@/components/textEditor/devExtremeEditor";
import dropZoneCustom from '@/components/DropZoneCustom'
import alert from '@/plugins/AlertMessages.js'
import label from "@/plugins/StaticLabels.js";
import { contentLanguage } from "@/plugins/ContentLangMixin.js";

export default {
  name: "EditPage",
  mixins: [devExtremeEditor, contentLanguage],
  computed: {
    ...mapGetters({
      postCheck: 'postCheck',
      page: 'baseX/page',
      loadingBtn: 'loadingBtn',
      imageUrl: 'imageUrl',
    }),
  },
  components: {
    dropZoneCustom
  },
  watch: {
    postCheck() {
      if (this.postCheck === true) {
        this.$router.push({name: 'ManagePages'})
      }
    },
    page() {
      this.imageName = this.page.imageName
      this.imageAddress = this.page.imageAddress
      this.dropZoneAction = false
      this.pageName = this.page.name.replace("/page/", "");
    },
    imageUrl() {
      if (this.imageUrl && this.imageUrl.length > 0) {
        this.refreshImage = false
        this.dropZoneAction = false
        this.imageName = this.imageUrl[0].fullPath
        this.imageAddress = this.imageUrl[0].fileAddress
        this.$nextTick(() => {
          this.refreshImage = true
        });
        setTimeout(() => {
          this.$store.commit("setLoadingBtn", false);
        }, 800);
      }
    },
  },
  data() {
    return {
      refreshImage: true,
      dropZoneAction: true,
      imageName: null,
      imageAddress: null,
      image: null,
      pageName: null,
      label
    }
  },
  methods: {
    blockSpecialChar(e) {
      var k = e.keyCode;
      return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || (k >= 48 && k <= 57));
    },
    handleImageUpload(file) {
      this.image = file;
    },
    editPage() {
      this.$store.commit("setLoadingBtn", true);
      this.page.name = this.pageName;
      if(this.page.title && this.page.title != ''
        && this.page.name && this.page.name != ''
        && this.page.shortDescription && this.page.shortDescription != '') {
        const formData = new FormData();
        if (this.page.title) {
          formData.append('Title', this.page.title);
        }
        if (this.page.name) {
          if (/[^A-Za-z\d]/.test(this.page.name)) {
            const msg = 'لطفا آدرس صفحه را به صورت انگیسی و اعداد و بدون فاصله وارد کنید';
            this.$store.commit('setError', msg);
            this.$store.commit("setLoadingBtn", false);
          } else {
            if (this.page.name.indexOf("page/") === 0 || this.page.name.indexOf("https") === 0 || this.page.name.indexOf("http") === 0) {
              formData.append('Name', this.page.name);
            } else if (this.page.name.indexOf("page/") !== 0) {
              formData.append('Name', "/page/" + this.page.name);
            }
          }
        }
        if (this.page.shortDescription) {
          formData.append('ShortDescription', this.page.shortDescription);
        }
        if (this.page.text) {
          formData.append('Text', this.page.text);
        }
        if (this.imageName) {
          formData.append('ImageName', this.imageName);
        }
        formData.append('IsConfirm', this.page.isConfirm);
        formData.append('languageId', this.selectedLanguage);
        const values = {
          id: this.$route.params.id,
          value: formData
        };
        this.$store.dispatch('baseX/editPage', values);
      } else {
        this.$store.commit('setError', alert.error.empty)
        this.$store.commit("setLoadingBtn", false);
      }
    }
  },
  beforeCreate() {
    this.$store.dispatch('baseX/getPageById', this.$route.params.id);
  }
}
</script>
